import $ from './jquery.js';

$('[data-toggle="navigation"]').click(function(e) {
	if(!$(this).data('allow-default')) {
		e.preventDefault();
	}
	$('html, body').toggleClass('nav-expanded');
});

// Add span for when there's a subnav on mobile
if ($(window).width() < 768) {
	// Set this ID to whatever your nav element has
	var $subnav = $("#menu-primary-menu li").has("ul");
	var more = $("<span class='more'>+</span>");

	if ($subnav.has("ul")) {
		// Add the more span
		$subnav.prepend(more);
	};

	$('body').on('click', '.more', function(){
		// Toggle the subnav
		$(this).siblings('.sub-menu').slideToggle();
	});
}
